module.exports = __webpack_public_path__ + "static/media/DuraCraft.ab008352.svg";